module.exports = __webpack_public_path__ + "img/logo-horus-footer2.9e864823.png";